import leftArrow from "@assets/carousel/arrow-l.svg";
import rightArrow from "@assets/carousel/arrow-r.svg";
import { useIsClient } from "@src/app/hooks/useIsClient";
import clsx from "clsx";

import { ARROW_OFFSET_CALC, MOBILE_ARROW_OFFSET } from "./constants";
import type { CustomArrowProps } from "./types";

interface CustomArrowComponentProps extends CustomArrowProps {
  isSmallScreen: boolean;
  padding: string;
}

export default function CustomArrow({
  direction,
  onClick,
  isSmallScreen,
  padding,
}: CustomArrowComponentProps) {
  const isClient = useIsClient();

  // 箭头样式计算
  const getArrowStyles = (direction: "left" | "right") => {
    const isLeftArrow = direction === "left";

    if (!isClient) {
      return {
        right: isLeftArrow ? "24px" : "auto",
        left: !isLeftArrow ? "24px" : "auto",
      };
    }

    const position = isSmallScreen
      ? MOBILE_ARROW_OFFSET
      : `calc(${padding} - ${ARROW_OFFSET_CALC}px)`;

    return {
      right: isLeftArrow ? position : "auto",
      left: !isLeftArrow ? position : "auto",
    };
  };

  const isLeftArrow = direction === "left";
  const arrowSrc = isLeftArrow ? rightArrow : leftArrow;

  return (
    <button
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className={clsx(
        isLeftArrow ? "custom-arrow-left" : "custom-arrow-right",
        "absolute z-[12] box-border flex size-[40px] cursor-pointer items-center justify-center rounded-full bg-button-secondary p-[8px] hover:bg-button-secondary-hover max-lg:top-[calc((100vw-24px)/3)] lg:top-1/2 lg:-translate-y-1/2",
        isLeftArrow ? "right-[24px]" : "left-[24px]",
      )}
      style={getArrowStyles(direction)}
      onClick={onClick}
    >
      <img src={arrowSrc} alt="arrow" />
    </button>
  );
}
